import React, { Component } from "react";
import { API } from "aws-amplify";
import { LinkContainer } from "react-router-bootstrap";
import 'react-table/react-table.css';
import 'containers/common/Detail.css';
import axios from 'axios';


import {  Form, Row, Col, Card,  Tabs, Tab, Button,   Alert, Nav } from "react-bootstrap";
// import { browserHistory } from 'react-router'
import Select from 'react-select';

import { css } from '@emotion/core';
import { PacmanLoader } from 'react-spinners';
import Moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();


export default class QueryDetail extends Component {
    constructor(props) {
        super(props);

        this.updateTableState = this.updateTableState.bind(this);
        this.saveRecord = this.saveRecord.bind(this); 
        this.refreshDataSet = this.refreshDataSet.bind(this);
        this.validateRelatedRecord = this.validateRelatedRecord.bind(this);

        this.state = {
            isLoading: null,
            isDeleting: null,
            modified: false,

            idList: [],
            previousId: -1,
            nextId: -1,

            query: null,       
            showAlert: false,
            errorMessage: "",
            selectedQueryType: null,
            queryTypeOptions: [],

            query_id: null,   
            property_id: null,
            property_key: null,
            title_details: null,
            query_type_code: null, 
            query_type: null, 
            date_to_resolve: null, 
            entered_by: null, 
            problem: null, 
            active: null, 
            doc_number: null, 
            perpetual: null,      
            created_date: null,
            created_by: null,
            last_edited_date: null,
            last_edited_by: null

        };



       

    }

    
    componentWillReceiveProps(prevProps) {
        
        if (prevProps.location.pathname !== this.props.location.pathname) {
            // Clean component and reload? 
            console.log("Resetting");
            window.location.reload();
        }
    }

    componentWillUnmount() {
        source.cancel();
        this.setState({ proposal: [] });
     
    }

  
    async componentDidMount() {
        

        try {
            this.setState({ isLoading: true });   

            if (this.props.match.params.id === "new") {
                console.log("New query");
                
                
                this.setState({ created_date: new Date()
                            ,date_to_resolve: new Date() 
                            , created_by: this.props.user 
                            , property_key: this.props.match.params.propertyid
                      
                            , active: true 
                            , perpetual: false },this.syncroniseState);
               
            }
            else {
                
                await this.retrieveQuery();
                if (this.props.location.state){
                    if (this.props.location.state.hasOwnProperty("data")){
                    
                        const idList = this.props.location.state.data;
                        var currentIdIndex = idList.indexOf(parseInt(this.props.match.params.id,10));

                        let nextId = null;
                        let previousId = null;
                        
                        if (currentIdIndex+1 < idList.length){
                            nextId = idList[currentIdIndex+1];
                            
                        }
                        if (currentIdIndex >0){
                            previousId = idList[currentIdIndex-1];                            
                        }
                        this.setState({idList: idList,nextId: nextId, previousId: previousId, currentIdIndex: currentIdIndex});

                    }                
                }
            }
            

            //Get lookups
            this.setState({ selectedQueryType: { value: this.state.query_type_code, label: this.state.query_type } });
            await this.getQueryTypes();

            document.title = this.state.property_key+" query" ;




            
            this.setState({ isLoading: false });   
        } catch (e) {
            alert(e);
        }
    }


    async syncroniseState() {

        const query = {
            query_id: this.state.query_id,
            property_id: this.state.property_id,
            property_key: this.state.property_key,
            title_details: this.state.title_details,
            query_type_code: this.state.query_type_code,
            query_type: this.state.query_type,
            date_to_resolve: this.state.date_to_resolve,
            entered_by: this.state.entered_by,
            problem: this.state.problem,
            active: this.state.active,
            doc_number: this.state.doc_number,
            perpetual: this.state.perpetual,    
            created_date: this.state.created_date,
            created_by: this.state.created_by,
            last_edited_date: this.state.last_edited_date,
            last_edited_by: this.state.last_edited_by
        };

        this.setState({ query });
    }

    async retrieveQuery() {
        const query = await this.getQuery();

        const {
            query_id,
            property_id,
            property_key,
            title_details,
            query_type_code,
            query_type,
            date_to_resolve,
            entered_by,
            problem,
            active,
            doc_number,
            perpetual, 
            created_date,
            created_by,
            last_edited_date,
            last_edited_by } = query;

        this.setState({
            query,
            query_id,
            property_id,
            property_key,
            title_details,
            query_type_code,
            query_type,
            date_to_resolve,
            entered_by,
            problem,
            active,
            doc_number,
            perpetual, 
            created_date,
            created_by,
            last_edited_date,
            last_edited_by
        });
    }



    //Call API
    


    async  getQuery() {
        try {
            const result = API.get("colin", `/properties/` + this.state.property_id + `/queries/${this.props.match.params.id}`);
            return result
        }
        catch{
            console.log("Error getting the entity");
        }
        
    }

    async saveQuery(query) {
        console.log("Inside save query");

        this.setState({ last_edited_by: this.props.user });

        if (this.props.match.params.id === "new") {  
            this.setState(state => ({ created_by: this.props.user }));
            const response =  API.post("colin", `/properties/${this.props.match.params.propertyid}/queries/new`, { body: query  });
                try {
                    return await response;
        
                } catch (error) {
                    alert(error+". Please refresh the page (F5) to try again.")
                };
            }
        
        return API.put("colin", `/properties/` + this.state.property_key + `/queries/${this.state.query_id}`, {  body: query });
        try {
            const response =  await response;

        } catch (error) {
            alert(error+". Please refresh the page (F5) to try again.")
        };
    }

    


    
   
    getQueryTypes() {
        try {
            API.get("colin", "/querytypes").then((queryTypeOptions) => {
                if (queryTypeOptions) {
                    this.setState(state => ({ queryTypeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting query types");
        }
    }

  

    



    

    refreshDataSet = async (dataset) => {
        //Get nabers records
        console.log("Inside refresh ");

        
    }

    
    

    updateTableState(data, set) {
        this.setState({
            [set]: data
        });
    }

    saveRecord(record, endpoint, id) {
        console.log("Inside property save - " + endpoint + " - " + id + " - " + record);
        record.last_edited_by = this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                record.last_edited_by = this.props.user;
                return API.post("colin", `/properties/${this.state.property_id}/${endpoint.toLowerCase()}/new`, {
                    body: record
                });
            }
        }
        //If not a new record and updating an existing, perform a put
        return API.put("colin", `/properties/${this.state.property_id}/${endpoint.toLowerCase()}/${record[id]}`, {
            body: record
        }
        );
    }



    
    handleQueryTypeChange = (selectedQueryType) => {       
        this.setState({ selectedQueryType 
                        ,query_type_code: selectedQueryType.value
                        ,query_type: selectedQueryType.label 
                        , modified: true },this.handleBlur);        

    }


    handleEnterCurrentIdIndex = event =>{
        if(event.keyCode === 13 || event.keyCode === 9 ){
           this.handleGoToRecord();
        }
   }

    handleGoToRecord = event => {
        console.log(this.state.idList.length);
        if(this.state.currentIdIndex>=0 && this.state.currentIdIndex < this.state.idList.length){
            this.props.history.push({pathname:`/properties/${this.state.property_id}/queries/${this.state.idList[this.state.currentIdIndex]}`, state:{data: this.state.idList}});
        }
        else{
            alert("Page no not in range.");
        }
    }

    handleCurrentIdIndexChange =event =>{
        const val = event.target.value.replace(/[^0-9.]/g, "");
        this.setState({[event.target.id]: val-1});        
    }




    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }



    handleDateChange(date, name) {
        var options = {  year: 'numeric', month: 'long', day: 'numeric' };
        var dt = new Date(date);
        
        if (date) {
            this.setState({
                [name]: dt.toLocaleDateString('en-AU',options)
                , modified: true
            });
        }
        else {
            this.setState({
                [name]: null
                , modified: true });
        }
        
    }


    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
            , modified: true },this.handleBlur);
        
    }


    
    validateRelatedRecord(record, set) {
        //property
        if (set === "query") {

            // secondly check that UnitSort has been specified if required
            if (!this.state.query_type_code) {
                return [false, "Query type cannot be empty. The record has not been saved"];
            }
            console.log("Inside validate query");

        }


        return [true,];
    }
    
    handleBlur = async event => {
        
        if (this.state.modified === true) {
            this.setState({ showAlert: false, last_edited_by: this.props.user });
            await this.syncroniseState();
            


            const validation = this.validateRelatedRecord(this.state.query, "query");
            console.log(validation)
            if (validation[0] === true) {
                try {
                    this.setState(state => ({ modified: false }));
                    if (this.props.match.params.id === "new") {
                        this.setState({ isLoading: true });
                    }
                    console.log("Saving query");
                    const result = await this.saveQuery(this.state.query);
                    this.setState({ isLoading: false });
                   
                    if (result.result === false) {
                        alert(result.error_message);
                    }
                    else {
                        if (this.props.match.params.id === "new") {
                            this.setState(state => ({ query_id: result.id }));
                            
                            this.props.history.push("/properties/" + this.state.property_key +"/queries/" + this.state.query_id);
                        }
                    }



                } catch (e) {
                    alert(e);

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }

        }

    }

    

    

    handleDelete = async event => {
        event.preventDefault();

        if (!this.state.registered) {
            const confirmed = window.confirm(
                "Are you sure you want to delete this query?"
            );

            if (!confirmed) {
                return;
            }
            else {
                this.setState({ archived_date: new Date() }, () =>
                    this.syncroniseState().then(async () => {
                        const result = await this.saveQuery(this.state.query);
                        if (result.result === false) {
                            alert(result.error_message);
                        }
                        else {

                            this.props.history.push("/properties/" + this.state.property_key);
                        }
                    }
                    )
                );

            }

        }
        else {
            window.alert("Lease records cannot be deleted");
        }
    }


    

    render() {
        return (
            <div className="Query">
                {this.state.isLoading &&
                <div className="outer-div"><div className='sweet-loading inner-div' >
                    <PacmanLoader
                        css={css`
                        display: block;
                        margin: 0 auto;
                        border-color: red`}
                        sizeUnit={"px"}
                        size={20}
                        color={'#e03c31'}
                        loading={this.state.isLoading}
                    />
                </div> 
                    </div>}
               
                {this.state.query && this.props.isAuthenticated && !this.state.isLoading &&
                    <div className="QueryForm">
                   
                    <Form  >
                        <Row>
                        <Col lg={3}></Col>
                        <Col>
                                <Nav className="justify-content-center " >
                                {this.state.previousId!== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/properties/${this.state.property_id}/queries/${this.state.previousId}`, state:{data: this.state.idList}}} >
                                            <Button type="button" variant="info"  size="sm">Previous</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                    {this.state.nextId!== null && this.state.idList.length>0 &&
                                    <Nav.Item  >
                                        <LinkContainer to={{pathname:`/properties/${this.state.property_id}/queries/${this.state.nextId}`, state:{data: this.state.idList}}} >
                                            <Button type="button" variant="info"  size="sm">Next</Button></LinkContainer>{" "}
                                    </Nav.Item>}
                                    {this.state.currentIdIndex!==null && this.state.idList.length>0 &&
                                        <Form.Group as={Row} controlId="currentIdIndex" >     
                                        <Col className="zeroPadRight">
                                            <Form.Control
                                                onChange={this.handleCurrentIdIndexChange}
                                                value={this.state.currentIdIndex+1}
                                                as="input"
                                                type="text"
                                                min="0"
                                                className="pageCount"
                                                onBlur={this.handleGoToRecord}
                                                onKeyDown={this.handleEnterCurrentIdIndex}
                                            />
                                            </Col>                               
                                            <Col  className="zeroPadLeft">
                                            <h6><div className="topPad">of {this.state.idList.length} {" "}</div></h6>
                                            </Col>
                                            
                                        </Form.Group>
                                         
                                    }
                                    </Nav>
                                </Col>
                            
                            <Col>
                        <Nav className="justify-content-end " >
                            <Nav.Item  >
                            <LinkContainer to={`/properties/${this.state.property_key}/#queries`} >
                                <Button size="sm" variant="primary" type="button">Back to Property {this.state.property_key}</Button></LinkContainer>{" "}
                        </Nav.Item>
                        <Nav.Item className="mr-1">
                            <LinkContainer to={`/properties/${this.state.property_key}/queries/new`}>
                                <Button variant="secondary" size="sm">Add</Button>
                            </LinkContainer>
                        </Nav.Item>
                        <Nav.Item  >
                                <Button
                                    variant="danger"
                                    onClick={this.handleDelete}
                                    type="button"
                                    size="sm"
                                >Delete</Button>
                                </Nav.Item>
                                </Nav>
                            </Col>
                        </Row>
                    <Row  id="detail">
                        <Col>
                        <Alert show={this.state.showAlert} variant="danger">{this.state.errorMessage}</Alert> 
                        <Tabs defaultActiveKey={0} id="tabset">
                                    <Tab eventKey={0} title="Query Detail">
                        <Card >
                                <Card.Header >
                                
                                        Query Details - {this.state.property_key} - {this.state.title_details}  
                            
                            </Card.Header>

                                
                                    <Card.Body>
                                        

                                    <Form.Row >
                                           
                                            <Col sm={12} md={6} lg={3}>

                                                <Card >
                                                    
                                                    <Card.Body>
                                                        <Form.Group as={Row} controlId="property_key" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Cityscope Ref.</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.property_key}
                                                                    as="input"
                                                                    type="text"
                                                                    

                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="created_date" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Date Entered</Form.Label>
                                                            <Col>
                                                                <DatePicker
                                                                    selected={new Date(this.state.created_date)}
                                                                    onChange={e => this.handleDateChange(e, "created_date")}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    onBlur={this.handleBlur}
                                                                    className="form-control"
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="active" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Query Active</Form.Label>
                                                            <Col >
                                                                <Form.Check checked={this.state.active}
                                                                    onChange={this.handleCheckBoxChange}
                                                                    label=""
                                                                    type="checkbox"
                                                                    name="active"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="date_to_resolve" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Date To Resolve</Form.Label>
                                                            <Col>
                                                                <DatePicker
                                                                    selected={new Date(this.state.date_to_resolve)}
                                                                    onChange={e => this.handleDateChange(e, "date_to_resolve")}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    onBlur={this.handleBlur}
                                                                    className="form-control"
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="query_type_code" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Type</Form.Label>
                                                            <Col>
                                                                <Select
                                                                    value={this.state.selectedQueryType}
                                                                    onChange={this.handleQueryTypeChange}
                                                                    options={this.state.queryTypeOptions}
                                                                    onInputChange={this.handleInputChange}
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="perpetual" >
                                                            <Form.Label className="text-right" column sm={6} md={6} lg={4}>Perpetual</Form.Label>
                                                            <Col >
                                                                <Form.Check checked={this.state.perpetual}
                                                                    onChange={this.handleCheckBoxChange}
                                                                    label=""
                                                                    type="checkbox"
                                                                    name="perpetual"
                                                                    onBlur={this.handleBlur}
                                                                />
                                                            </Col>

                                                        </Form.Group>
                                                        <Form.Group as={Row} controlId="created_by" >
                                                            <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Entered By</Form.Label>
                                                            <Col>
                                                                <Form.Control
                                                                    onChange={this.handleChange}
                                                                    value={this.state.created_by}
                                                                    as="input"
                                                                    type="text"
                                                                    readOnly

                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                            <Form.Group as={Row} controlId="doc_number" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Document No.</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        onChange={this.handleChange}
                                                                        value={this.state.doc_number}
                                                                        as="input"
                                                                        type="text"
                                                                    onBlur={this.handleBlur}
                                                                    />
                                                                </Col>

                                                            
                                                        </Form.Group>


                                                    </Card.Body>
                                                    </Card>
                                                </Col>

                                            <Col sm={12} md={8} lg={6}>

                                                <Card >

                                                    <Card.Body>

                                                        <Form.Group as={Row} controlId="problem" >
                                                            <Form.Label className="text-right">Query Details</Form.Label>

                                                            <Form.Control
                                                                onChange={this.handleChange}
                                                                value={this.state.problem}
                                                                as="textarea"
                                                                rows="12"
                                                                onBlur={this.handleBlur}
                                                            />

                                                        </Form.Group>

                                                        <Form.Group as={Row} controlId="title" >
                                                                <Form.Label as={Col} className="text-right" column sm={6} md={6} lg={4}>Title Details</Form.Label>
                                                                <Col>
                                                                    <Form.Control
                                                                        disabled
                                                                        value={this.state.title_details}
                                                                        as="input"
                                                                        type="text"
                                                                  
                                                                    />
                                                                </Col>

                                                            
                                                        </Form.Group>

                                                    </Card.Body>
                                                </Card>
                                       


                                            </Col>


                                            <Col sm={12} md={6} lg={3}>

                                                <Card >

                                                    <Card.Body>



                                                    </Card.Body>
                                                </Card>



                                            </Col>


                                           
                                            

                                            
                                         


                                    </Form.Row>






                                </Card.Body>
                            
                        </Card >
                        </Tab>

                              <Tab eventKey={1} title="Record History">
                                        <Card style={{ width: '28rem' }}>
                                    <Card.Body>
                                                <Form.Group as={Row} controlId="created_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_date!= null ? Moment(this.state.created_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="created_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Created By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.created_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_date" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited Date</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_date!= null ? Moment(this.state.last_edited_date)
                                                                .local()
                                                                .format("DD-MM-YYYY"): ""}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                                <Form.Group as={Row} controlId="last_edited_by" >
                                                    <Form.Label className="text-right" column sm={6} md={6} lg={4}>Last Edited By</Form.Label>
                                                    <Col>
                                                        <Form.Control
                                                            value={this.state.last_edited_by}
                                                            plaintext readOnly
                                                        />
                                                    </Col>
                                                </Form.Group>

                                    </Card.Body>
                                </Card>

                            </Tab>

                        
                        </Tabs>

                        </Col>

                    </Row>
                   

                   
                    
                        
                    </Form>
                
                    </div>

                }
            </div>
        );
    }
}